
export default {
  name: 'Card',
  props: {
    labels: {
      type: Object,
      default: () => {},
    },
    fields: {
      type: Object,
      default: () => {},
    },
    isCardNumberMasked: Boolean,
  },
  data() {
    return {
      focusElementStyle: null,
      currentFocus: null,
      isFocused: false,
      isCardFlipped: false,
      amexCardPlaceholder: '#### ###### #####',
      dinersCardPlaceholder: '#### ###### ####',
      defaultCardPlaceholder: '#### #### #### ####',
      currentPlaceholder: '',
    }
  },
  computed: {
    cardType() {
      const number = this.labels.numeroCartao

      if (/^4/.test(number)) {
        return 'visa'
      }

      if (/^(34|37)/.test(number)) {
        return 'amex'
      }

      if (/^5[1-5]/.test(number)) {
        return 'mastercard'
      }

      if (/^6011/.test(number)) {
        return 'discover'
      }

      if (/^62/.test(number)) {
        return 'unionpay'
      }

      if (/^9792/.test(number)) {
        return 'troy'
      }

      if (/^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/.test(number)) {
        return 'dinersclub'
      }

      if (/^35(2[89]|[3-8])/.test(number)) {
        return 'jcb'
      }

      return ''
    },
  },
  watch: {
    currentFocus() {
      if (this.currentFocus) {
        this.changeFocus()
      } else {
        this.focusElementStyle = null
      }
    },
    cardType() {
      this.changePlaceholder()
    },
  },

  mounted() {
    this.changePlaceholder()
    const self = this
    const fields = document.querySelectorAll('[data-card-field]')
    fields.forEach((element) => {
      element.addEventListener('focus', () => {
        this.isFocused = true

        this.isCardFlipped = element.id === this.fields.codigoSeguranca
      })
      element.addEventListener('blur', () => {
        this.isCardFlipped = !element.id === this.fields.codigoSeguranca
        setTimeout(() => {
          if (!self.isFocused) {
            self.currentFocus = null
          }
        }, 300)
        self.isFocused = false
      })
    })
  },

  methods: {
    changeFocus() {
      const target = this.$refs[this.currentFocus]
      this.focusElementStyle = target
        ? {
            width: `${target.offsetWidth}px`,
            height: `${target.offsetHeight}px`,
            transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`,
          }
        : null
    },
    getIsNumberMasked(index, n) {
      return (
        index > 4 &&
        index < 14 &&
        this.labels.numeroCartao.length > index &&
        n.trim() !== '' &&
        this.isCardNumberMasked
      )
    },
    changePlaceholder() {
      if (this.cardType === 'amex') {
        this.currentPlaceholder = this.amexCardPlaceholder
      } else if (this.cardType === 'dinersclub') {
        this.currentPlaceholder = this.dinersCardPlaceholder
      } else {
        this.currentPlaceholder = this.defaultCardPlaceholder
      }
      this.$nextTick(() => {
        this.changeFocus()
      })
    },
  },
}
